import React from 'react';

const TermsConditions = () => {
  return (
    <div className="policy-container">
      <h1>Terms & Conditions</h1>
      <p><strong>Last Updated:</strong> 27/05/2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using https://impactjournal.co.in ("Site"), you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree, please do not use this Site.</p>

      <h2>2. User Registration</h2>
      <p>To submit manuscripts or access certain features, users must register by providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.</p>

      <h2>3. Manuscript Submission</h2>
      <p>By submitting a research paper, you confirm that it is original work, free from plagiarism, and that you have the right to submit it. Impact Journal reserves the right to accept, reject, or remove submissions at its discretion.</p>

      <h2>4. Publication Fees</h2>
      <p>Fees charged for manuscript processing, review, and publication are non-refundable once payment is processed. Charges are clearly displayed before final submission.</p>

      <h2>5. Certificate Issuance</h2>
      <p>Certificates are issued only for accepted and published research papers. They are digitally generated and made available for download from your account dashboard.</p>

      <h2>6. Intellectual Property</h2>
      <p>Authors retain copyright of their work. However, by submitting to Impact Journal, you grant us a non-exclusive license to publish, distribute, and display your content online and in print.</p>

      <h2>7. Prohibited Activities</h2>
      <ul>
        <li>Uploading plagiarized or fraudulent content</li>
        <li>Sharing or selling login credentials</li>
        <li>Attempting to hack, exploit, or disrupt the platform</li>
        <li>Misuse of certificates or published content</li>
      </ul>

      <h2>8. Limitation of Liability</h2>
      <p>Impact Journal is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our platform, including content accuracy or availability.</p>

      <h2>9. Changes to Terms</h2>
      <p>We may update these Terms & Conditions at any time. Continued use of the Site after changes indicates your acceptance of the updated terms.</p>

      <h2>10. Governing Law</h2>
      <p>These terms are governed by and construed under the laws of India. Any disputes shall be resolved in the jurisdiction of [Insert City/State].</p>

      <h2>11. Contact</h2>
      <p>For questions about these Terms, contact:</p>
      <p><strong>Email:</strong> support@impactjournal.co.in</p>
    </div>
  );
};

export default TermsConditions;
